import React from 'react';
import { IFeeSection } from '../organizeFees';
import { getColumns } from './getColumns';
import {
  StyledTableNumberColumn,
  StyledTable,
  StyledTableContent,
  StyledTableHeader,
  StyledTableRow,
} from './StyledTable';
import { TotalsRow } from './TotalsRow';
import { useSelectCurrentOrder } from '../../../../selectors/order/selectCurrentOrder';
import { eTransactionCategory } from '../../../../ui-toolkit/enums/eTransactionType';
import { eFeePropertyNames } from '../../../../types/order/fees/eFeePropertyNames';
import { OrderFeeContainer } from '../OrderFeeContainer';
import { ISettlementItemData } from 'types/order/fees/ISectionData';
import { FeeSectionTableColumnHeaders } from './FeeSectionTableColumnHeaders';

export interface IFeeSectionTableProps {
  feeSection: IFeeSection;
  items?: ISettlementItemData[];
  indexOffset?: number;
  blankRows?: number;
  isRefinance?: boolean;
  layout: 'Single Column' | 'Two Column';
}

export const FeeSectionTable: React.FC<IFeeSectionTableProps> = ({
  feeSection,
  isRefinance = false,
  items = feeSection.settlementItems,
  indexOffset = 0,
  blankRows = 0,
  layout,
}) => {
  const currentOrder = useSelectCurrentOrder();
  const columns = getColumns(
    feeSection,
    currentOrder.data.transaction.transaction_category === eTransactionCategory.Refinance
  );
  const hiddenTotals = feeSection.sectionDefinition.sectionPropertyTotalNames.includes(eFeePropertyNames.HiddenTotals);
  const columnsCount = columns.filter((t) => t.isVisible === undefined).length;
  const columnTemplate = isRefinance
    ? `36px auto 360px 130px 120px 128px 128px 108px 36px`
    : `36px auto 200px 130px 120px 128px 128px 128px 128px 108px 36px`;
  return (
    <StyledTable columnCount={columnsCount} gridTemplateColumn={columnTemplate}>
      <StyledTableHeader>
        <StyledTableRow className={`items-end`}>
          <StyledTableNumberColumn />
          <FeeSectionTableColumnHeaders
            columns={columns}
            feeSectionTotals={feeSection.sectionData?.sectionPropertyTotals}
          />

          <div></div>
        </StyledTableRow>
      </StyledTableHeader>
      <StyledTableContent>
        {items.map((item, i) => (
          <OrderFeeContainer
            layout={layout}
            key={item.settlementStatementItemId}
            fee={item}
            columns={columns}
            index={i + indexOffset}
            feeSection={feeSection}
          />
        ))}
        {feeSection.sectionData && !hiddenTotals && <TotalsRow columns={columns} feeSection={feeSection} />}
        {[...Array(blankRows)].map((e, i) => (
          <StyledTableRow className={`items-end`} key={i}>
            <StyledTableNumberColumn className={'p-4'}>&nbsp;</StyledTableNumberColumn>
          </StyledTableRow>
        ))}
      </StyledTableContent>
    </StyledTable>
  );
};
